(ns manatee.components.modal.view
  (:require [manatee.components.modal.subs :as subs]
            [re-frame.core :as rf]
            [rothko.panel-modal.component :refer [panel-modal]]))

(defn modal-container
  [{:keys [id] :as attrs-and-props} & children]
  (when @(rf/subscribe [::subs/visible? id])
    (into [panel-modal (merge {:appearance #{:primary}}
                              attrs-and-props)]
          children)))
